import React from 'react'

const Icon = (props) => {
    return (
    <i className={"fas " + props.icon}></i>
    )
}

export default Icon